var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHibernateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.536 0l12.31 21.32L13.53 42.67 1.228 21.32z",
    fill: "#59666c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.16.001H13.543l12.31 21.32h24.624z",
    fill: "#bcae79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.464 64l-12.31-21.32L50.47 21.33 62.772 42.68z",
    fill: "#59666c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 63.998h24.62l-12.3-21.32H13.523z",
    fill: "#bcae79"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernateIcon);
export default __webpack_public_path__ + "static/media/hibernate-icon.b60d22ea89273c1fb65ee77356d4b5a7.svg";
export { ForwardRef as ReactComponent };